var ShopSwitch = (function() {
  function ShopSwitch(element) {
    this.element = element;
    this.settings = JSON.parse(this.element.getAttribute('data-section-settings'));

    this.templates = {
      switcher: document.querySelector('[switcher-template]').innerHTML,
      country: document.querySelector('[country-template]').innerHTML
    };

    this.data = {
      currentCountry: this.settings.countries.find(o => o.current) || {},
      cookie: this.getCookie(this.settings.cookieName),
      geoData: JSON.parse(localStorage.getItem('geodata')) || undefined
    };

    // Create the modal element
    this.createModal();

    if (window.isBot || !this.settings['apiKey']) return;

    if (window.top.location.search.indexOf('switch') !== -1) {
      this.setCookie(this.settings.cookieName, this.data.currentCountry.domain);
      this.data.cookie = this.data.currentCountry.domain;
    }
    if (this.settings.hreflangManagerTag) {
      this.findHreflangManagerTag();
    }
    if (this.settings.switcherEnable) {
      this.initializeSwitcher();
    }

    this.attachListeners();
    if (this.data.cookie !== this.data.currentCountry.domain || window.socialReferrer || this.settings.testMode) {
      if (this.data.geoData) {
        this.handleLocation();
      } else {
        this.loadLocation().then(() => this.handleLocation());
      }
    }
  }

  ShopSwitch.prototype.createModal = function() {
    // Create the modal container
    this.modal = document.createElement('div');
    this.modal.className = 'shop-switch-modal';
    this.modal.style.display = 'none';
    this.modal.setAttribute('role', 'dialog');
    this.modal.setAttribute('aria-modal', 'true');
    this.modal.setAttribute('aria-hidden', 'true');
    this.modal.setAttribute('tabindex', '-1');
    
    // Link modal to its title if it exists
    const titleElement = this.element.querySelector('#shop-switch-title');
    if (titleElement) {
      this.modal.setAttribute('aria-labelledby', 'shop-switch-title');
    }

    // Create the overlay
    this.overlay = document.createElement('div');
    this.overlay.className = 'shop-switch-overlay';
    this.overlay.setAttribute('aria-hidden', 'true');
    
    // Create the modal content container
    this.modalContent = document.createElement('div');
    this.modalContent.className = 'shop-switch-modal-content';
    
    // Copy the content from the original modal
    const originalModalContent = this.element.querySelector('.Modal__Content');
    if (originalModalContent) {
      this.modalContent.innerHTML = originalModalContent.innerHTML;
    }
    
    // Add the header
    const header = document.createElement('div');
    header.className = 'shop-switch-modal-header';
    const originalHeader = this.element.querySelector('.Modal__Header');
    if (originalHeader) {
      header.innerHTML = originalHeader.innerHTML;
    }
    
    // Add close button
    const closeButton = document.createElement('button');
    closeButton.className = 'shop-switch-close-button';
    closeButton.innerHTML = '×';
    closeButton.setAttribute('aria-label', 'Close modal');
    closeButton.setAttribute('type', 'button');
    header.appendChild(closeButton);
    
    // Add screen reader announcement
    const srAnnouncement = document.createElement('div');
    srAnnouncement.className = 'sr-only';
    srAnnouncement.setAttribute('aria-live', 'polite');
    srAnnouncement.setAttribute('aria-atomic', 'true');
    srAnnouncement.id = 'shop-switch-announcement';
    
    // Assemble the modal
    this.modal.appendChild(header);
    this.modal.appendChild(this.modalContent);
    this.modal.appendChild(srAnnouncement);
    
    // Add to the document
    document.body.appendChild(this.overlay);
    document.body.appendChild(this.modal);
    
    // Store references
    this.closeButton = closeButton;
    this.srAnnouncement = srAnnouncement;
    this.previouslyFocusedElement = null;
  };

  ShopSwitch.prototype.openModal = function() {
    // Store the currently focused element
    this.previouslyFocusedElement = document.activeElement;
    
    this.overlay.style.display = 'block';
    this.modal.style.display = 'block';
    document.body.style.overflow = 'hidden';
    
    // Update ARIA attributes
    this.overlay.setAttribute('aria-hidden', 'false');
    this.modal.setAttribute('aria-hidden', 'false');
    
    // Announce modal opening to screen readers
    this.announceToScreenReader('Shop switch modal opened. Use Tab to navigate, Escape to close.');
    
    // Focus the modal
    this.modal.focus();
    
    // Set up focus trap
    this.setupFocusTrap();
  };

  ShopSwitch.prototype.closeModal = function(saveCookie) {
    this.overlay.style.display = 'none';
    this.modal.style.display = 'none';
    document.body.style.overflow = '';
    
    // Update ARIA attributes
    this.overlay.setAttribute('aria-hidden', 'true');
    this.modal.setAttribute('aria-hidden', 'true');
    
    this.removeFocusTrap();
    
    // Restore focus to previously focused element
    if (this.previouslyFocusedElement && this.previouslyFocusedElement.focus) {
      this.previouslyFocusedElement.focus();
    }
    
    // Announce modal closing to screen readers
    this.announceToScreenReader('Shop switch modal closed.');
    
    if (saveCookie) {
      this.onStayClose();
    }
  };

  ShopSwitch.prototype.initializeSwitcher = function() {
    var context = {
      currentTitle: this.data.currentCountry.title,
      currentImg: this.data.currentCountry.img,
      currentCurrency: this.data.currentCountry.currency ? `(${this.data.currentCountry.currency})` : '',
      countries: this.settings.countries.sort((a, b) => a.current === b.current ? 0 : a.current ? -1 : 1)
    };

    var template = this.renderTemplate(this.templates.switcher, context);
    document.querySelectorAll('.shop-switch__switcher').forEach(function(elem) {
      elem.innerHTML = template;
    });
  };

  ShopSwitch.prototype.attachListeners = function() {
    // Attach close button event
    if (this.closeButton) {
      this.closeButton.addEventListener('click', () => this.closeModal(true));
    }
    
    // Add toggle button listener
    const toggleButton = document.querySelector('.shop-switch-toggle-wrapper');
    
    document.addEventListener('click', (event) => {
        if (event.target.closest('.shop-switch-toggle-wrapper') || event.target === toggleButton) {
          this.openModal();
        }
    });
    
    // Close on overlay click without saving cookie
    this.overlay.addEventListener('click', () => this.closeModal(false));
    
    // Prevent clicks inside the modal from closing it
    this.modal.addEventListener('click', function(event) {
      event.stopPropagation();
    });
    
    // Find the dismiss button in the copied content and attach event
    const dismissButton = this.modal.querySelector('.shop-switch__dismiss button');
    if (dismissButton) {
      dismissButton.addEventListener('click', () => this.closeModal(true));
    }
    
    // Add keyboard navigation
    this.modal.addEventListener('keydown', (event) => this.handleKeydown(event));
  };

  ShopSwitch.prototype.findHreflangManagerTag = function() {
    document.querySelectorAll('head > link').forEach((linkElement) => {
      var hreflang = linkElement.getAttribute('hreflang');
      if (hreflang) {
        var theHrefUrl = linkElement.getAttribute('href').concat("?switch");
  
        this.modal.querySelectorAll('.CountriesList__item').forEach(function(anchorElement) {
          var countryCode = anchorElement.getAttribute('data-countrycode');
  
          if (countryCode === hreflang) {
            anchorElement.setAttribute('href', theHrefUrl);
          }
        });
      }
    });
  };

  ShopSwitch.prototype.onStayClose = function() {
    this.setCookie(this.settings.cookieName, this.data.currentCountry.domain);
    this.data.cookie = this.data.currentCountry.domain;
  };

  ShopSwitch.prototype.setCookie = function(name, value) {
    document.cookie = name + "=" + value + ";path=/;expires=" + this.settings.delayDays;
  };

  ShopSwitch.prototype.getCookie = function(name) {
    var value = "; " + document.cookie;
    var parts = value.split("; " + name + "=");
    if (parts.length === 2) return parts.pop().split(";").shift();
    else return null;
  };

  ShopSwitch.prototype.renderTemplate = function(template, context) {
    return template.replace(/\{\{(\w+)\}\}/g, function(match, key) {
      return context[key] || '';
    });
  };

  ShopSwitch.prototype.loadLocation = function() {
    const url = "https://api.ipstack.com/check?access_key=" + this.settings['apiKey'];
    this.log('Loading:' + url);
    return fetch(url)
      .then(response => response.json())
      .then(data => {
        console.log(data);
        window.ipstack = data;
        return data;
      });
  };

  ShopSwitch.prototype.handleLocation = function() {
    // Retrieve location data
    let locationData;
    if (this.data.geoData) {
      locationData = this.data.geoData.country_code;
    } else {
      locationData = window.ipstack.country_code;
      localStorage.setItem('geodata', JSON.stringify(window.ipstack));
      this.data.geoData = JSON.parse(localStorage.getItem('geodata'));
    }
    
    if (!locationData) {
      console.log('Could not get location based on IP');
      return;
    }
  
    const ipCountryCode = locationData;
    
    // Helper function to find index based on condition
    const findIndex = (array, condition) => {
      for (let i = 0; i < array.length; i++) {
        if (condition(array[i])) {
          return i;
        }
      }
      return -1;
    };
    
    // Find indices for the IP, default, and current countries
    const ipIndex = findIndex(this.settings.countries, (o) => {
      if (o.country_code.includes(',')) {
        const countryCodes = o.country_code.split(',').map((code) => code.trim());
        return countryCodes.includes(ipCountryCode);
      }
      return o.country_code === ipCountryCode;
    });
    const defaultIndex = findIndex(this.settings.countries, (o) => o.default);
    const currentIndex = findIndex(this.settings.countries, (o) => o.current);
    
    const ipDomain = ipIndex >= 0 ? this.settings.countries[ipIndex].domain : undefined;
    const defaultDomain = defaultIndex >= 0 ? this.settings.countries[defaultIndex].domain : undefined;
    const currentDomain = currentIndex >= 0 ? this.settings.countries[currentIndex].domain : undefined;
    
    // Determine if action is required based on domains
    if (ipDomain === currentDomain || (!ipDomain && currentDomain === defaultDomain)) {
      // No action needed
    } else {
      const newDomain = ipDomain || defaultDomain;
      
      if (this.settings.testMode) {
        console.info('[Shop Switch] Designated shop: ' + newDomain);
      }
      
      if (this.settings.mode === 'enabled' || this.settings.testMode) {
        this.initPopupDelay();
      } else if (this.settings.mode === 'redirect' && !Shopify.designMode) {
        const newIndex = findIndex(this.settings.countries, (o) => o.domain === newDomain);
        if (newIndex >= 0) {
          this.redirect(this.settings.countries[newIndex].url);
        }
      }
    }
  };

  ShopSwitch.prototype.initPopupDelay = function() {
    setTimeout(() => {
      this.openModal();
    }, this.settings.delaySeconds * 1000);
  };

  ShopSwitch.prototype.redirect = function(url) {
    window.location.href = url;
  };

  ShopSwitch.prototype.log = function(message) {
    if (this.settings.testMode) {
      console.log('%c[Shop Switch] ' + message, 'color: blue;', 'color: black;');
    }
  };

  // Accessibility methods
  ShopSwitch.prototype.setupFocusTrap = function() {
    this.focusableElements = this.getFocusableElements();
    this.firstFocusableElement = this.focusableElements[0];
    this.lastFocusableElement = this.focusableElements[this.focusableElements.length - 1];
  };

  ShopSwitch.prototype.removeFocusTrap = function() {
    this.focusableElements = null;
    this.firstFocusableElement = null;
    this.lastFocusableElement = null;
  };

  ShopSwitch.prototype.getFocusableElements = function() {
    const focusableSelectors = [
      'button:not([disabled])',
      'input:not([disabled])',
      'select:not([disabled])',
      'textarea:not([disabled])',
      'a[href]',
      '[tabindex]:not([tabindex="-1"])'
    ];
    
    return Array.from(this.modal.querySelectorAll(focusableSelectors.join(', ')));
  };

  ShopSwitch.prototype.handleKeydown = function(event) {
    if (event.key === 'Escape') {
      event.preventDefault();
      this.closeModal(true);
      return;
    }

    if (event.key === 'Tab') {
      if (!this.focusableElements || this.focusableElements.length === 0) {
        return;
      }

      if (event.shiftKey) {
        // Shift + Tab
        if (document.activeElement === this.firstFocusableElement) {
          event.preventDefault();
          this.lastFocusableElement.focus();
        }
      } else {
        // Tab
        if (document.activeElement === this.lastFocusableElement) {
          event.preventDefault();
          this.firstFocusableElement.focus();
        }
      }
    }
  };

  ShopSwitch.prototype.announceToScreenReader = function(message) {
    if (this.srAnnouncement) {
      this.srAnnouncement.textContent = message;
      // Clear the message after a short delay to allow for re-announcement
      setTimeout(() => {
        this.srAnnouncement.textContent = '';
      }, 1000);
    }
  };

  return ShopSwitch;
})();

// Initialize on DOM ready
document.addEventListener('DOMContentLoaded', function() {
  const shopSwitchElement = document.getElementById('shop-switch');
  if (shopSwitchElement) {
    new ShopSwitch(shopSwitchElement);
  }
});
  